<template>
  <div
    class="input-radio"
    role="group"
  >
    <template
      v-for="{
        checked,
        inputKey,
        labelKey,
        title,
        value,
      } in options"
    >
      <input
        class="input-radio__input"
        type="radio"
        v-bind:checked="checked"
        v-bind:key="inputKey"
        v-bind:id="inputKey"
        v-bind:name="identifier"
        v-bind:value="value"
        v-on:input="onInput(value)">
      <label
        class="input-radio__title"
        v-bind:class="{ checked }"
        v-bind:for="inputKey"
        v-bind:key="labelKey"
      >{{ title }}</label>
    </template>
  </div>
</template>
<script>
/**
 * @description Компонент замещаемого выбора.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Отображаемые опции.
     */
    options() {
      return this.items.map(({ title, value }) => ({
        checked: this.value === value,
        inputKey: `${this.identifier}:${value}:input`,
        labelKey: `${this.identifier}:${value}:label`,
        title,
        value,
      }));
    },
  },
  methods: {
    /**
     * @description Обработать выбор элемента.
     * @param {string} value
     * @returns {void}
     */
    onInput(value) {
      this.$emit('input', value);
    },
  },
  name: 'InputRadio',
  props: {
    /**
     * @description Идентификатор опций.
     */
    identifier: {
      required: true,
      type: String,
    },
    /**
     * @description Возможные значения.
     */
    items: {
      required: true,
      type: Array,
    },
    /**
     * @description Допускается пустое значение.
     */
    optional: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Значение.
     */
    value: {
      required: true,
      type: String,
    },
  },
};
</script>
<style scoped>
.input-radio {
  display: flex;
  flex-direction: row;
}

.input-radio .input-radio__input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

.input-radio .input-radio__title {
  align-items: center;
  background: var(--fill-color);
  color: var(--reading-color);
  cursor: pointer;
  display: flex;
  font-size: .875rem;
  font-weight: 400;
  height: 2.5rem;
  justify-content: center;
  line-height: 1.065rem;
  padding: 0 .8125rem;
}

.input-radio .input-radio__title:first-of-type {
  border-bottom-left-radius: var(--input-border-radius);
  border-top-left-radius: var(--input-border-radius);
}

.input-radio .input-radio__title:last-of-type {
  border-bottom-right-radius: var(--input-border-radius);
  border-top-right-radius: var(--input-border-radius);
}

.input-radio .input-radio__input:focus:not(:checked) + .input-radio__title {
  background: var(--unfocus-color);
  color: var(--primary-background-color);
}

.input-radio .input-radio__title.checked,
.input-radio .input-radio__title:hover {
  background: var(--action-color);
  color: var(--primary-background-color);
}
</style>
